interface ShouldSuggestLocationDeleteParams {
  activeCount: number
  isDefault: boolean
  affectedUserWasActive: boolean
}

export const shouldSuggestLocationDelete = (params: ShouldSuggestLocationDeleteParams): boolean => {
  const { activeCount, isDefault, affectedUserWasActive } = params
  return !isDefault && activeCount === (affectedUserWasActive ? 1 : 0)
}
